/**
 * Refetch the signed-in reader's tabs when they come back to the page.
 *
 * Tabs are drawn from a copy kept in the browser, and that copy goes stale
 * whenever the sprites behind it are rebuilt elsewhere: a cell added from
 * another tab or device, or an editor accepting a new logo for a site in the
 * reader's tabs. Pusher was meant to announce the first (it never announced
 * the second) and was removed on 2026-09-28. Coming back to the page is the
 * moment a stale tab would be noticed, so that is when to check - at most
 * every MIN_INTERVAL_MS, since the request returns every tab and cell.
 */
const MIN_INTERVAL_MS = 5 * 60 * 1000;

let lastRefresh = Date.now();

/**
 * Start listening. `refresh` is called when the page becomes visible again
 * and `isSignedIn()` is true; returns a function that stops listening.
 */
export default function refreshTabsOnReturn(isSignedIn, refresh) {
  const onVisibility = () => {
    if (document.visibilityState !== 'visible' || !isSignedIn()) return;
    if (Date.now() - lastRefresh < MIN_INTERVAL_MS) return;
    lastRefresh = Date.now();
    refresh();
  };

  document.addEventListener('visibilitychange', onVisibility);
  return () => document.removeEventListener('visibilitychange', onVisibility);
}
